import styled from 'styled-components';
import theme from '../../../theme';
import { getCleanMoment } from '../../../utils/dateTimeUtils';

const STATUS_INTERVAL_IN_MINUTES = 30;

const StopEtaStatus = {
  EXPECTED_EARLY: 'EXPECTED_EARLY',
  EXPECTED_ON_TIME: 'EXPECTED_ON_TIME',
  EXPECTED_DELAY: 'EXPECTED_DELAY',
};

const StopEtaStatusColor = {
  EXPECTED_EARLY: theme.color.primary,
  EXPECTED_ON_TIME: theme.color.ignition.on,
  EXPECTED_DELAY: theme.color.danger,
};

export const StopEtaStatusDisplay = styled.span`
  font-weight: 500;
  color: ${({ status }) => StopEtaStatusColor[status]};
`;

export const resolveStatus = (scheduledArrival, estimatedArrival) => {
  // Missing either side (malformed ETA / stop) degrades to "on time" rather than throwing on the
  // getCleanMoment(...).unix() below — matching the pre-normalisation NaN-fallthrough behaviour.
  if (!scheduledArrival || !estimatedArrival) {
    return StopEtaStatus.EXPECTED_ON_TIME;
  }
  // scheduledArrival (stop.timeSlot.start) arrives in milliseconds while estimatedArrival
  // (eta.eta.arrival) is in seconds. Normalise both to epoch seconds via getCleanMoment (which
  // handles s / ms / ISO input) before comparing, otherwise the raw subtraction is off by ~1000x
  // and every stop reads as EXPECTED_EARLY (PORTAL-6277).
  const scheduledSeconds = getCleanMoment(scheduledArrival).unix();
  const estimatedSeconds = getCleanMoment(estimatedArrival).unix();
  const diffInMinutes = (scheduledSeconds - estimatedSeconds) / 60;
  if (diffInMinutes > STATUS_INTERVAL_IN_MINUTES) {
    return StopEtaStatus.EXPECTED_EARLY;
  }
  if (diffInMinutes < -STATUS_INTERVAL_IN_MINUTES) {
    return StopEtaStatus.EXPECTED_DELAY;
  }
  return StopEtaStatus.EXPECTED_ON_TIME;
};
